/* Native tag links do the filtering. This script preserves previews and migrates old URLs. */
(() => {
  'use strict';
  if (window.rdtnCollectionCategoriesLoaded) return;
  window.rdtnCollectionCategoriesLoaded = true;
  const initialPreview = new URL(window.location.href).searchParams.get('preview_theme_id');

  function migrateCategoryUrl(input, config) {
    const url = new URL(input, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    const path = url.pathname.match(/^(.*\/collections\/([^/]+))(?:\/([^/]+))?\/?$/);
    if (!path) return null;
    let changed = false;
    let handles = (path[3] || '').split('+').filter(Boolean);
    const view = (url.searchParams.get('view') || '').match(/^(e36|e38|e39|e46|e9x)-(repair|storage|phone|driving|controls|exterior)$/);
    if (view && view[1] === path[2]) {
      const category = ['controls', 'exterior'].includes(view[2]) ? 'driving' : view[2];
      const categoryHandles = Object.values(config.tags);
      handles = handles.filter((handle) => !categoryHandles.includes(handle) && !Object.hasOwn(config.legacyTags, handle));
      handles.push(config.tags[category]);
      url.searchParams.delete('view');
      changed = true;
    }
    handles = handles.map((handle) => {
      if (!Object.hasOwn(config.legacyTags, handle)) return handle;
      changed = true;
      return config.tags[config.legacyTags[handle]];
    });
    if (!changed) return null;
    url.pathname = path[1] + (handles.length ? '/' + [...new Set(handles)].join('+') : '');
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections');
    url.hash = 'ChassisCategories';
    return url;
  }

  function init() {
    const configNode = document.querySelector('[data-rdtn-category-config]');
    if (!configNode) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch (error) { return; }
    const current = new URL(window.location.href);
    const migrated = migrateCategoryUrl(current.href, config);
    if (migrated && migrated.href !== current.href) {
      window.location.replace(migrated.href);
      return;
    }
    const preview = current.searchParams.get('preview_theme_id') || initialPreview;
    document.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || !href.includes('/collections/')) return;
      try {
        const migratedLink = migrateCategoryUrl(href, config);
        const target = migratedLink || new URL(href, window.location.origin);
        if (target.origin !== window.location.origin) return;
        if (preview && (migratedLink || link.hasAttribute('data-rdtn-category'))) {
          target.searchParams.set('preview_theme_id', preview);
          link.href = target.href;
        } else if (migratedLink) {
          link.href = target.href;
        }
      } catch (error) { /* Leave unrelated or malformed links untouched. */ }
    });
    document.querySelectorAll('[data-rdtn-category]').forEach(prepareCategoryLink);
    document.querySelectorAll('.rdtn-chassis-categories__links').forEach((nav) => {
      const active = nav.querySelector('[aria-current="page"]');
      if (active && nav.scrollWidth > nav.clientWidth) {
        nav.scrollLeft += active.getBoundingClientRect().left - nav.getBoundingClientRect().left - (nav.clientWidth - active.clientWidth) / 2;
      }
    });
  }
  // The native sorting UI updates only the product grid, not this header.
  // Refresh links at click time so switching category preserves the current sort.
  function prepareCategoryLink(link) {
    try {
      const current = new URL(window.location.href);
      const target = new URL(link.href, window.location.origin);
      if (target.origin !== window.location.origin) return;
      const sort = current.searchParams.get('sort_by');
      if (sort) target.searchParams.set('sort_by', sort);
      else target.searchParams.delete('sort_by');
      const preview = current.searchParams.get('preview_theme_id') || initialPreview;
      if (preview) target.searchParams.set('preview_theme_id', preview);
      target.searchParams.delete('page');
      link.href = target.href;
    } catch (error) { /* Preserve the server-rendered link on unexpected input. */ }
  }
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-rdtn-category]');
    if (link) prepareCategoryLink(link);
  }, true);
  // Keep native facet and sorting requests in the same unpublished preview.
  if (initialPreview) document.addEventListener('formdata', (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    if (event.target.closest('facets-form-component') && event.formData) {
      event.formData.set('preview_theme_id', initialPreview);
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
